/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  CertifiedPlantType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface DeleteCertifiedPlantInput {
  plantId: string;
}
const build = (_query: DocumentNode, input: DeleteCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    deleteCertifiedPlant(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' }
    ){
      ...certifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class DeleteCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment certifiedplanttype on CertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: DeleteCertifiedPlantInput): Promise<apollo.FetchResult< { deleteCertifiedPlant: Partial<CertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ deleteCertifiedPlant: Partial<CertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
